<template>
	<div class="container__crud">
		<div class="container__crudactions">
			<div class="container__crudactions__cruddownload">
				<div class="container__crudactions__cruddownload__crud">
					<Button
						:label="$t('deleteSelected')"
						color="trv-error"
						outlined
						icon="far fa-trash-alt"
						semantic-class="tiny"
						:disabled="isDeleteButtonDisabled"
						width-auto
						@click="toggleExclusionAlert"
					/>
					<ExclusionAlert
						v-if="showExclusionAlert"
						:items-to-delete="modelList.filter((item) => item.isCheckedToDelete)"
						@cancel="toggleExclusionAlert"
						@confirm="deleteModels"
					>
						<template #item="{ item }">
							<li class="exclusion-alert-item">
								{{ $t('code') }} : {{ item.ptio_cd_codigo }} - {{ $t('talhao') }} :
								{{ item.talhao }}
							</li>
						</template>
					</ExclusionAlert>
					<!-- <Button
            :label="$t('create')"
            color="trv-default"
            semanticClass="tiny"
            @click="showNewModelForm"
            widthAuto
          /> -->
				</div>
				<!-- <div class="container__crudactions__cruddownload__download">
          <DownloadButton />
        </div> -->
			</div>
			<div class="container__crudactions__filtercollums">
				<div class="container__crudactions__filtercollums__filter">
					<InputSearch
						v-model="textFilter"
						style="margin-right: 0.5rem"
						:placeholder="$t('search')"
					/>
				</div>
				<div
					class="container__crudactions__filtercollums__collumns"
					style="display: flex"
				>
					<DropdownCheckbox v-model="tableHeaders" />
					<Button
						:label="$t('export')"
						semantic-class="mini"
						color="trv-primary"
						outlined
						width-auto
						style="border-radius: 5px !important; min-width: 65px"
						:loading="exportando"
						@click="downloadCSVPlantio()"
					/>
				</div>
			</div>
		</div>
		<CrudTable
			:headers="headersAtivos"
			:data="modelsToBeShowedAndTotal.items"
			:table-configuration="tableConfiguration"
			:show-edit-model-form="showEditModelForm"
			@sortConfig="
				sortBy = $event.sortBy
				sortType = $event.sortType
			"
		>
			<template #outer-action-button="dataObject">
				<KebabMenu
					v-model="intention"
					:options="kebabOptions"
					:properties="dataObject"
				/>
			</template>
		</CrudTable>
		<div class="container__crud__pagination">
			<GridPagination
				ref="ref__pagination"
				:quantity-per-page="10"
				:quantity-per-page-options="[10, 20, 30]"
				:total-records="totalRecords"
				@setStartEnd="setStartEnd"
				@setQuantityPerPage="setQuantityPerPage"
				@refreshTable="refreshTabela"
			/>
		</div>
		<CrudForm
			:is-visible="showForm"
			:change-is-visible="changeFormAndCloseAllActions"
			:title-form="titleForm"
			:backdrop="true"
		>
			<template #form>
				<div style="display: flex; flex-direction: column; gap: 0.5rem">
					<Switcher
						v-model="model.ativo"
						style="margin-top: 1rem"
						:label="$t('activePlanting')"
						:disabled="criandoTalhao"
						@input="atualiza_status_plantio()"
					/>

					<InputText
						v-model="model.ptio_cd_codigo"
						:label="$t('code') + '*'"
					/>

					<DropdownFk
						v-model="model.fk_tlho_talhao"
						:label="$t('section') + '*'"
						:dropdown-options="talhoes"
					/>
					<!-- <InputText
            :label="$t('code')"
            v-model="model.ptio_cd_codigo"
          /> -->

					<DatePicker
						v-model="model.ptio_dt_plantio"
						:label="$t('plantationDate') + '*'"
					/>

					<!-- <Accordion
            :label="$t('optionalFields')"
            :hints="[$t('forestStratification'), $t('geneticMaterial'), $t('area')]"
          > -->
					<div style="display: flex; flex-direction: column; gap: 0.5rem">
						<DropdownFk
							v-model="model.fk_esfl_estrato_florestal"
							:label="$t('forestStratification')"
							:dropdown-options="estratoFlorestais"
						/>

						<DropdownFk
							v-model="model.fk_mtge_material_genetico"
							:label="$t('geneticMaterial')"
							:dropdown-options="materiaisGeneticos"
						/>
						<InputText
							v-model="model.ptio_nr_area_efetiva"
							:label="`${$t('area')} (ha)`"
							:mask="['#', '#.#', '#.##', '##.##', '###.##', '####.##', '#####.##', '######.##']"
						/>

						<InputText
							v-model.number="model.ptio_nr_fustes"
							:label="$t('numberOfStems')"
						/>
						<InputText
							v-model.number="model.ptio_nr_erro_fustes"
							:label="$t('errorOfNStems')"
						/>
						<InputText
							v-model="model.ptio_tx_espacamento"
							:label="$t('spacing')"
						/>
						<InputText
							v-model="model.ptio_nr_rotacao"
							:label="$t('rotation')"
							mask="###"
						/>
						<InputText
							v-model="model.ptio_nm_tipo_manejo"
							:label="$t('management')"
						/>
						<InputText
							v-model="model.ptio_nm_tipo_adubacao"
							:label="$t('fertilizing')"
						/>
						<InputText
							v-model="model.ptio_nr_ciclo"
							:label="$t('cicle')"
							mask="###"
						/>

						<DatePicker
							v-model="model.ptio_dt_colheita"
							:label="$t('harvestDate')"
						/>
					</div>
					<!-- </Accordion> -->
					<Accordion :label="`${$t('customVariables')}`">
						<div
							v-if="model.ptio_jsonb_custom_variable?.length"
							style="display: flex; flex-wrap: wrap; gap: 0.5rem; padding: 0.5rem"
						>
							<Tag
								v-for="{ name, value } in model.ptio_jsonb_custom_variable"
								:key="name"
								:identificador-da-tag="{ name, value }"
								:label="`${name}: ${value}`"
								:class-name="['default', 'outlined']"
							/>
						</div>
						<div v-else>Variáveis não foram cadastradas</div>
					</Accordion>
				</div>

				<div class="container__crud__crudform__buttons">
					<Button
						:label="$t('save')"
						color="trv-default"
						semantic-class="mini"
						:disabled="disableSaveButton || !camposObrigatoriosPreenchidos"
						@click="saveClick()"
					/>
					<Button
						:label="$t('cancel')"
						color="trv-default"
						semantic-class="mini"
						outlined
						@click="changeFormAndCloseAllActions"
					/>
				</div>
			</template>
		</CrudForm>

		<ModalConfirmPlantio
			v-if="showModalConfirmacao"
			:disabled_item="model.ptio_cd_codigo"
			@desativar_registro="desativar_plantio()"
			@cancelar_desativacao="cancelar_desativar_plantio()"
		/>

		<ModalError
			v-if="showModalError"
			:ordens_servico="ordensDeServico"
			:disabled_item="model.ptio_cd_codigo"
			:item_type="$t('planting')"
			@fechar_model_error="fecha_model_error()"
		/>
	</div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

import Accordion from '../../../../components/Accordion/Accordion'
import Button from '../../../../components/Button/Button'
import CrudForm from '../../../../components/CrudForm/CrudForm'
import CrudTable from '../../../../components/CrudTable/CrudTable'
import DatePicker from '../../../../components/DatePicker/DatePicker'
// import DownloadButton from "../../../../components/DownloadButton/DownloadButton";
import DropdownCheckbox from '../../../../components/DropdownCheckbox/DropdownCheckbox'
import DropdownFk from '../../../../components/DropdownFk/DropdownFk'
import InputSearch from '../../../../components/InputSearch/InputSearch'
import InputText from '../../../../components/InputText/InputText'
import KebabMenu from '../../../../components/KebabMenu/KebabMenu'
import Tag from '../../../../components/Tag/Tag'
import Switcher from '../../../../components/Switcher/Switcher'
import ControllingPaginationMixins from '../../../../mixins/ControllingPaginationMixins'
import RegistersMixins from '../../../../mixins/RegistersMixins'
import { exportarCsv } from '../../../../utils/csvHellpers'
import ModalConfirmPlantio from '../../../../components/ModalConfirmPlantio/ModalConfirmPlantio.vue'
import ModalError from '../../../../components/ModalError/ModalError.vue'
import GridPagination from '../../../../components/GridPagination/GridPagination.vue'
import {
	createPlantio,
	deletePlantioByIdList,
	updatePlantio,
	getAllPlantiosPagination,
} from '../../../../services/requests/PlantioRequests'

import { getDropdownEstratosFlorestais } from '../../../../services/requests/EstratoFlorestalRequests'
import { getDropdownMateriaisGeneticos } from '../../../../services/requests/MaterialGeneticoRequests'
import { getDropdownTalhoes } from '../../../../services/requests/TalhaoRequests'

import validarPlantio from '../../../../validations/PlantioValidation'
import ExclusionAlert from '../../../../components/ExclusionAlert/ExclusionAlert.vue'

export default {
	components: {
		Accordion,
		Button,
		CrudForm,
		CrudTable,
		DatePicker,
		KebabMenu,
		// DownloadButton,
		DropdownCheckbox,
		DropdownFk,
		InputSearch,
		InputText,
		GridPagination,
		Tag,
		Switcher,
		ExclusionAlert,
		ModalConfirmPlantio,
		ModalError,
	},
	/**
	 * Mixins
	 * - ControllingPaginationMaxins: Mixin para controler a paginacao
	 * - RegistersMixins: Mixin com funções compartilhadas para realizar o CRUD
	 */
	mixins: [ControllingPaginationMixins, RegistersMixins],
	data() {
		return {
			intention: {},
			showModalConfirmacao: false,
			textFilter: '',
			totalRecords: 0,
			exportando: false,
			showModalError: false,
			desativou_plantio: false,
			showExclusionAlert: false,
			headersSelecionados: [
				'materialGenetico',
				'dataDoPlantioParaTabela',
				'ptio_nr_area_efetiva',
				'estradoFlorestal',
				'talhao',
				'ptio_cd_codigo',
				'ativo',
			],
			/**
			 * Campos que devem ser feito bind para cadastro ou edicao de registro
			 */
			model: {
				id: '',
				fk_tlho_talhao: '',
				fk_esfl_estrato_florestal: '',
				ptio_dt_plantio: '',
				fk_mtge_material_genetico: '',
				ptio_tx_espacamento: '',
				ptio_nr_area_efetiva: '',
				ptio_nr_ciclo: '',
				ptio_nr_rotacao: '',
				ptio_nm_tipo_manejo: '',
				ptio_dt_colheita: '',
				ptio_nm_tipo_adubacao: '',
				ptio_cd_codigo: '',
				ptio_nr_fustes: '',
				ptio_nr_erro_fustes: '',
				ptio_jsonb_custom_variable: [],
				ativo: true,
				estradoFlorestal: '',
				materialGenetico: '',
				talhao: '',
				dataDoPlantioParaTabela: '',
				dataDaColheitaParaTabela: '',
			},
			/**
			 * Configuração da tabela
			 */
			tableConfiguration: {
				statusTable: this.$t('loading') + '...',
				subtitleCardPropertie: 'ptio_cd_codigo',
				titleCardPropertie: 'ptio_cd_codigo',
			},
			tableHeaders: [
				{ key: 'ptio_cd_codigo', value: this.$t('code'), isActive: true },
				{ key: 'talhao', value: this.$t('section'), isActive: true },
				{
					key: 'estradoFlorestal',
					value: this.$t('forestStratification'),
					isActive: true,
				},
				{
					key: 'ptio_nr_area_efetiva',
					value: this.$t('effectiveArea'),
					isActive: true,
				},
				{
					key: 'dataDoPlantioParaTabela',
					value: this.$t('plantationDate'),
					isActive: true,
				},
				{
					key: 'materialGenetico',
					value: this.$t('geneticMaterial'),
					isActive: true,
				},
				{
					key: 'ptio_tx_espacamento',
					value: this.$t('spacing'),
					isActive: false,
				},
				{ key: 'ptio_nr_ciclo', value: this.$t('cicle'), isActive: false },
				{ key: 'ptio_nr_arvores', value: this.$t('trees'), isActive: false },
				{ key: 'ptio_nr_fustes', value: this.$t('stems'), isActive: false },
				{
					key: 'ptio_nr_rotacao',
					value: this.$t('rotation'),
					isActive: false,
				},
				{
					key: 'ptio_nm_tipo_manejo',
					value: this.$t('management'),
					isActive: false,
				},
				{
					key: 'dataDaColheitaParaTabela',
					value: this.$t('harvestDate'),
					isActive: false,
				},
				{
					key: 'ptio_nm_tipo_adubacao',
					value: this.$t('fertilizing'),
					isActive: false,
				},
				{
					key: 'ativo',
					value: this.$t('registration_status'),
					isActive: false,
				},
			],
			/**
			 * talhoes que serão dispostas no dropdown para atrelar ao plantio
			 */
			talhoes: [],

			/**
			 * estratos florestal que serão dispostos no dropdown para atrelar ao plantio
			 */
			estratoFlorestais: [],

			/**
			 * materiais geneticos que serão dispostos no dropdown para atrelar ao plantio
			 */
			materiaisGeneticos: [],
		}
	},
	computed: {
		customs() {
			return this.modelList.filter((model) => model.ptio_jsonb_custom_variable?.length)
		},
		kebabOptions() {
			return [
				{
					value: 'editar',
					label: this.$t('edit'),
				},
			]
		},
		headersAtivos() {
			const ativos = this.tableHeaders.filter((f) => this.headersSelecionados.includes(f.key))

			ativos.forEach((f) => {
				f.isActive = true
			})

			return ativos
		},
		/**
		 * Retorna se os campos obrigatórios estão preenchidos
		 */
		camposObrigatoriosPreenchidos() {
			return this.model.ptio_cd_codigo && this.model.ptio_dt_plantio && this.model.fk_tlho_talhao
		},
	},
	watch: {
		tableHeaders: {
			deep: true,
			handler(value) {
				this.headersSelecionados = value.filter((f) => f.isActive).map((m) => m.key)
			},
		},
		intention(value) {
			const model = this.modelList.find((model) => model.id === value.properties.id)

			switch (value.intent) {
				case 'editar':
					this.showEditModelForm(model)
					break
			}
		},

		textFilter(value) {
			const pageNumber = 0
			const pageSize = 0
			this.refreshTabela(pageNumber, pageSize, value)
			this.$refs.ref__pagination.resetToFirstPageInputHandle()
		},
	},
	/**
	 * Antes de criar o objeto seta a quantidade de itens por pagina
	 * e a ordenacao da tabela
	 */
	created() {
		this.quantityPerPage = 10
		this.orderTable = ['ptio_cd_codigo']

		getAllPlantiosPagination().then((response) => {
			const plantios = response.data.result
			this.totalRecords = plantios.length > 0 ? plantios[0].totalRegistros : 0
			plantios.forEach((plantio) => this.formataPlantioParaTabela(plantio))
			this.modelList = plantios
			this.tableConfiguration.statusTable = this.$t('noRecordFound')
		})

		getDropdownTalhoes().then((response) => {
			this.talhoes = response
		})

		getDropdownEstratosFlorestais().then((response) => {
			this.estratoFlorestais = response
		})

		getDropdownMateriaisGeneticos().then((response) => {
			this.materiaisGeneticos = response
		})
	},
	methods: {
		/**
		 * Cria o objeto que deve ser enviado para o backend para ser
		 * criado no banco de dados
		 */

		toggleExclusionAlert() {
			this.showExclusionAlert = !this.showExclusionAlert
		},
		createModelToPost() {
			return {
				id: uuidv4(),
				fk_tlho_talhao: this.model.fk_tlho_talhao,
				fk_esfl_estrato_florestal: this.model.fk_esfl_estrato_florestal,
				ptio_dt_plantio: this.model.ptio_dt_plantio,
				fk_mtge_material_genetico: this.model.fk_mtge_material_genetico,
				ptio_tx_espacamento: this.model.ptio_tx_espacamento,
				ptio_nr_area_efetiva: this.model.ptio_nr_area_efetiva,
				ptio_nr_ciclo: this.model.ptio_nr_ciclo,
				ptio_nr_rotacao: this.model.ptio_nr_rotacao,
				ptio_nm_tipo_manejo: this.model.ptio_nm_tipo_manejo,
				ptio_dt_colheita: this.model.ptio_dt_colheita,
				ptio_nm_tipo_adubacao: this.model.ptio_nm_tipo_adubacao,
				ptio_cd_codigo: this.model.ptio_cd_codigo.trim(),
				ptio_nr_fustes: this.model.ptio_nr_fustes ? this.model.ptio_nr_fustes : 0,
				ptio_nr_erro_fustes: this.model.ptio_nr_erro_fustes ? this.model.ptio_nr_erro_fustes : 0,
			}
		},

		refreshTabela(pageNumber, pageSize, filteringWord) {
			getAllPlantiosPagination(pageNumber, pageSize, filteringWord).then((response) => {
				const plantios = response.data.result
				if (!plantios || plantios.length === 0) {
					return
				}
				plantios.forEach((plantio) => this.formataPlantioParaTabela(plantio))
				this.modelList = plantios
				this.tableConfiguration.statusTable = this.$t('noRecordFound')
			})
		},

		/**
		 * Baixa CSV com o resultado FILTRADO COMPLETO (nao so a pagina ja
		 * carregada): busca tudo numa chamada antes de gerar o arquivo,
		 * sem mexer no estado da grid.
		 */
		async downloadCSVPlantio() {
			if (this.exportando) return
			this.exportando = true
			try {
				const response = await getAllPlantiosPagination(
					0,
					Math.max(this.totalRecords, 100),
					this.textFilter,
				)
				const items = response.data.result || []

				const cabecalhoDoCsvPtio = [
					'Código',
					'Talhão',
					'Estrato Florestal',
					'Área Efetiva',
					'Data do Pantio',
					'Material Genético',
					'Espaçamento',
					'Ciclo',
					'Rotação',
					'Manejo',
					'Data da Colheita',
					'Adubação',
				]

				// Mesma formatacao aplicada pela grid (formataPlantioParaTabela)
				const linhas = items.map((item) => [
					item.ptio_cd_codigo,
					item.talhao,
					item.estradoFlorestal,
					item.ptio_nr_area_efetiva?.toFixed(2),
					item.ptio_dt_plantio,
					item.materialGenetico,
					item.ptio_tx_espacamento,
					item.ptio_nr_ciclo,
					item.ptio_nr_rotacao,
					item.ptio_nm_tipo_manejo,
					item.ptio_dt_colheita,
					item.ptio_nm_tipo_adubacao,
				])

				exportarCsv('export_plantio', cabecalhoDoCsvPtio, linhas)
			} finally {
				this.exportando = false
			}
		},

		desativar_plantio() {
			this.update()
		},

		atualiza_status_plantio() {
			if (this.model.ativo == false) {
				this.desativou_plantio = true
			} else {
				this.desativou_plantio = false
			}
		},

		fecha_model_error() {
			this.showModalError = false
		},

		cancelar_desativar_plantio() {
			this.desativou_plantio = false
			this.showModalConfirmacao = false
			window.location.reload()
		},

		/**
		 * Cria novo Plantio no banco de dados
		 */
		create() {
			const plantio = this.createModelToPost()
			const { isValid } = validarPlantio(plantio, this.modelList)

			if (isValid) {
				createPlantio(plantio).then((response) => {
					const { result: plantio, isError } = response.data
					this.disableSaveButton = false

					if (!isError) {
						this.cleanModel()
						this.formataPlantioParaTabela(plantio)
						this.modelList.unshift(plantio)

						this.showForm = false
						this.emptyValue = ''

						this.mutationShowMessage({
							messageTitle: this.$t('sucesso'),
							messageIcon: 'far fa-check-circle',
							messageType: 'success',
						})
					} else {
						this.mutationShowMessage({
							messageTitle: this.$t('erro'),
							messageIcon: 'far fa-check-circle',
							messageType: 'error',
						})
					}
				})
			} else {
				this.disableSaveButton = false
				this.mutationShowMessage({
					messageTitle: this.$t('campoPreenchidoIncorretamente'),
					messageIcon: 'fas fa-exclamation-circle',
					messageType: 'error',
				})
			}
		},

		/**
		 * Formata campos do model para exibir na tabela de crud
		 */
		formataPlantioParaTabela(plantio) {
			plantio.isCheckedToDelete = false
			plantio.ptio_nr_area_efetiva = plantio.ptio_nr_area_efetiva?.toFixed(2)
			plantio.ptio_nr_fustes = plantio.ptio_nr_fustes ? plantio.ptio_nr_fustes : ''
			plantio.ptio_nr_erro_fustes = plantio.ptio_nr_erro_fustes ? plantio.ptio_nr_erro_fustes : ''

			plantio.dataDoPlantioParaTabela = plantio.ptio_dt_plantio
				? new Date(plantio.ptio_dt_plantio).toLocaleDateString()
				: ''

			plantio.dataDaColheitaParaTabela = plantio.ptio_dt_colheita
				? new Date(plantio.ptio_dt_colheita).toLocaleDateString()
				: ''

			if (plantio.ativo == true) {
				plantio.ativo = this.$t('active')
			} else {
				plantio.ativo = this.$t('inactive')
			}
		},

		/**
		 * Atualiza fazenda no banco de dados
		 */
		update() {
			const request = {
				plantio: this.model,
				numeroDeFustes: this.model.ptio_nr_fustes ? this.model.ptio_nr_fustes : 0,
				erroFustes: this.model.ptio_nr_erro_fustes ? this.model.ptio_nr_erro_fustes : 0,
			}

			updatePlantio(request).then((response) => {
				const plantio = response.data.resultado
				this.disableSaveButton = false
				this.showModalConfirmacao = false
				const isError = response.status
				const ordensDeServico = response.data.ordensServicosAbertas

				if (isError == 200 && ordensDeServico.length == 0) {
					plantio.ptio_nr_erro_fustes = this.model.ptio_nr_erro_fustes
					this.formataPlantioParaTabela(plantio)

					const indexPlantio = this.modelList.map((plantio) => plantio.id).indexOf(plantio.id)
					this.$set(this.modelList, indexPlantio, plantio)

					this.showForm = false

					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})
				} else if (isError == 200 && ordensDeServico.length > 0) {
					this.showModalError = true
					this.ordensDeServico = response.data.ordensServicosAbertas
				} else {
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
					})
				}
			})
		},

		/**
		 * Exclui fazenda no banco de dados
		 */
		deleteModels(email) {
			var emailUsuario = localStorage.getItem('email')
			if (email === emailUsuario) {
				const existeRegistroComDependencia = this.modelList.filter(
					(plantio) =>
						this.modelsIdWithCheckedToDelete.includes(plantio.id) &&
						plantio.possuiDependenciaDeRegistro,
				)

				if (existeRegistroComDependencia.length == 0) {
					const confirmResult = confirm('Deseja realmente excluir esses registros?')

					if (confirmResult) {
						deletePlantioByIdList(this.modelsIdWithCheckedToDelete).then(() => {
							this.modelsIdWithCheckedToDelete.forEach((f) => {
								const indexToRemove = this.modelList.map((m) => m.id).indexOf(f)
								this.modelList.splice(indexToRemove, 1)
							})

							this.mutationShowMessage({
								messageTitle: this.$t('sucesso'),
								messageIcon: 'far fa-check-circle',
								messageType: 'success',
							})
							this.showExclusionAlert = false
						})
					}
				} else {
					var plantiosOrganizados = existeRegistroComDependencia
						.map(
							(plantio) =>
								`• Plantio: ${plantio.ptio_cd_codigo} / Estrato Florestal: ${plantio.estradoFlorestal}`,
						)
						.join('<br/>')
					var message = `<b>${this.$t('dependenciaDeEstratoOuParcela')}:</b> <br/><br/> ${plantiosOrganizados}`
					this.mutationShowMessage({
						messageTitle: this.$t('cuidado'),
						messageText: message,
						messageIcon: 'fas fa-exclamation-circle',
						messageType: 'warning',
					})
				}
			} else {
				this.mutationShowMessage({
					messageTitle: this.$t('wrongEmail'),
					messageIcon: 'fas fa-lock',
					messageType: 'error',
					messageText: this.$t('wrongEmaildescricao'),
				})
			}
		},

		/**
		 * Método executado quando clica no botão de salvar
		 */
		saveClick() {
			this.disableSaveButton = true
			if (this.isEdit) {
				if (this.desativou_plantio) {
					this.showModalConfirmacao = true
					this.showForm = false
					return
				}
				this.showForm = false
				if (this.model.ativo == 'Inativo') {
					this.model.ativo = false
				} else {
					this.model.ativo = true
				}
				this.update()
			} else {
				this.create()
			}
		},

		/**
		 * Configura para exibir o Model de edicao
		 */
		showEditModelForm(model) {
			this.model = Object.assign({}, model)

			this.titleForm = `${this.$t('edit')} ${this.$t('plantation')}`
			this.isEdit = true
			this.changeFormAndCloseAllActions()
			if (this.model.ativo == 'Inativo') {
				this.model.ativo = false
			}
		},

		/**
		 * Configura para exibir o Model de Cadastro
		 */
		showNewModelForm() {
			this.cleanModel()

			this.titleForm = `${this.$t('create')} ${this.$t('plantation')}`
			this.isEdit = false
			this.changeFormAndCloseAllActions()
		},

		/**
		 * Fecha o formulario e actions que estiverem abertas
		 */
		changeFormAndCloseAllActions() {
			this.showForm = !this.showForm
		},
	},
}
</script>

<style scoped src="../../../../css/crud.css"></style>
